<div class="pricing-hero-section">

  <div class="pricing-hero-heading-row">
    <h1 class="pricing-hero-title">Get More. Pay Less</h1>
    <img class="pricing-hero-deco" src="images/webps/three.png" alt="" aria-hidden="true" />
  </div>

  <div class="pricing-toggle">
    <span class="pricing-toggle-indicator" [class.is-yearly]="isYearly" aria-hidden="true"></span>
    <button
      class="pricing-toggle-btn"
      [class.active]="!isYearly"
      (click)="setYearly(false)">Monthly</button>
    <button
      class="pricing-toggle-btn"
      [class.active]="isYearly"
      (click)="setYearly(true)">Yearly</button>
  </div>
</div>
